import Bookingg from "../component/booking"
import Book from "../component/appointemtn"
function Booking(){
    return(
        <>
        <Bookingg/>
        <Book/>
        </>

    )
}
export default Booking